const AggregateCell = ({ cell }) => {
  const { isAggregated, isPlaceholder, render } = cell;

  if (isAggregated) {
    return render('Aggregated');
  }

  return isPlaceholder ? null : render('Cell');
};

export default AggregateCell;
